import {CloseReason, OrderStatus, TfOrder} from "../../types/Order";

export const OrderStatusFilter = "tfOrderStatus";

export function orderStatusFilter() {

    return (order: TfOrder) => {
        switch (order.status) {
            case OrderStatus.PENDING:
                return "order-status.PENDING";
            case OrderStatus.WAITING_OPERATOR:
                return "order-status.WAITING_OPERATOR";
            case OrderStatus.ON_MARKET:
                return "order-status.WORKING";
            case OrderStatus.DONE:
                return closedReason(order);
        }
    };
}

function closedReason(order: TfOrder): string {
    if (order.closedReason == null) {
        return "order.status.DONE";
    }

    switch (order.closedReason) {
        case CloseReason.REJECTED:
            return "order-status.REJECTED";
        case CloseReason.FAILED:
            return "order-status.FAILED";
        case CloseReason.CANCELLED:
            return "order-status.CANCELLED";
        case CloseReason.EXPIRED:
            return "order-status.EXPIRED";
        case CloseReason.FILLED:
            return "order-status.FILLED";
    }
}
